module.exports = __webpack_public_path__ + "static/img/financialmanagement.b03d893.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/financialmanagement.jpeg
// module id = AUYC
// module chunks = 7